<template>
  <div>
    <el-form :model="form">
      <el-form-item label="字符串" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off" style="width:300px"></el-input>
      </el-form-item>
      <el-form-item label="数字" :label-width="formLabelWidth">
        <el-input-number v-model="form.num"  :min="0" :controls="false"></el-input-number>
      </el-form-item>
      <el-form-item label="下拉" :label-width="formLabelWidth">
        <el-select v-model="form.region" placeholder="请选择活动区域" style="width:300px">
          <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    
  },
  data() {
    return {
      form: {
        name: '',
        region: '' 
      },
      formLabelWidth: '120px'
    }
  },
}
</script>

<style>

</style>